module.exports = __webpack_public_path__ + "id.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/id.svg
// module id = 604
// module chunks = 0